import { logger } from '@gem/modules/logger';

import { IE2eeCommit } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

const getRequest = async (
  groupId: string,
  epoch: number,
  acc: IE2eeCommit[] = []
): Promise<IE2eeCommit[]> => {
  const response = await e2eeModel.getCommits(epoch, groupId);

  if (response.nextCursor) {
    let lastEpoch = 0;
    response.commits.forEach((commit) => {
      if (commit.epoch > lastEpoch) {
        lastEpoch = commit.epoch;
      }
    });

    return await getRequest(groupId, lastEpoch, [...acc, ...response.commits]);
  }

  return [...acc, ...response.commits];
};

const getCommitMessagesPromisesMap = new Map<string, Promise<void>>();

const getCommitMessagesFunc = async (groupId: string, epoch: number): Promise<void> => {
  try {
    const response = await getRequest(groupId, epoch);
    const group = MlsStorageService.loadGroup(groupId);

    if (!group) {
      return;
    }

    response
      .sort((item1, item2) => item1.epoch - item2.epoch)
      .forEach((message) => {
        MlsStorageService.processCommitMessage(message, groupId);
      });
  } catch (error) {
    logger.get('Tasks').error('e2ee.getCommitMessages', error);
  } finally {
    getCommitMessagesPromisesMap.delete(groupId);
  }
};

export const getCommitMessages = async (groupId: string, currentEpoch: number): Promise<void> => {
  if (getCommitMessagesPromisesMap.has(groupId)) {
    return getCommitMessagesPromisesMap.get(groupId);
  } else {
    const epochFromCurrent = currentEpoch - 1;
    const promise = getCommitMessagesFunc(groupId, epochFromCurrent);
    getCommitMessagesPromisesMap.set(groupId, promise);
    return promise;
  }
};
